module.exports = __webpack_public_path__ + "img/d7113.8834c608.png";